$(document).ready(function() {
    // Add link in the Firmness Selector
    $('.variant-wrapper').eq(0).find('.variant__label').append(' <a href="#" class="sbly-popup-btn-info" id="sbly-height-info">Which height is right for me?</a>');
    $('.variant-wrapper').eq(1).find('.variant__label').append(' <a href="#" class="sbly-popup-btn-info" id="sbly-firmness-info">Which firmness is right for me?</a>');

    // Prepend the html after the <body> tag
     $('body').prepend(`
        <div id="sbly-info-popup" style="display:none;">
            <div class="sbly-popup-wrapper">
              <div id="sbly-popup-content"></div>
              <a id="sbly-popup-close"><i class="fa-sharp fa-solid fa-square-xmark"></i></a>
            </div>
        </div>
    `);

    $(document).on('click','.sbly-popup-btn-info', function() {
        var contentId = '';
        
        switch (this.id) {
            case 'sbly-height-info':
                contentId = '#sbly-height-content';
                break;
            case 'sbly-firmness-info':
                contentId = '#sbly-firmness-content';
                break;
        }
        
        var contentValue = $(contentId).html(); // Assuming the .val() would be the method to fetch data dynamically
        $('#sbly-popup-content').html(contentValue);
        
        $('#sbly-info-popup').show();
    });

    $(document).on('click', '#sbly-popup-close', function() {
        $('#sbly-info-popup').hide();
    });
  
    $(window).scroll(function() {
        var scrollValue = $(this).scrollTop();
    });

    var $addToCartButton = $('.add-to-cart');
    var $selectDropdown = $('select[name="id"]');
    
    function updateAddToCartPrice(priceText) {
        // Remove .00 and any currency code (like PHP) from the price text
        // Assumes price is always at the end and may optionally have .00 and a currency code
        var formattedPrice = priceText.replace(/\s+\w+$/, '').trim();
        $addToCartButton.text(`Add to Cart - ${formattedPrice}`);
    }
    
    $('.variant-input').click(function(event) {
        event.preventDefault(); // Prevent scrolling to top

        var $radioButton = $(this).find('input[type=radio]').prop('checked', true).trigger('change');
        
        var selectedThickness = $('input[name="Thickness"]:checked').val();
        var selectedFirmness = $('input[name="Firmness"]:checked').val();
        var selectedBundle = $('input[name="Bundle"]:checked').val();
        
        var optionTextToMatch = `${selectedThickness} / ${selectedFirmness} / ${selectedBundle}`;

        // Use .filter to find and select the matching option
        $selectDropdown.find('option').filter(function() {
            return $(this).text().includes(optionTextToMatch);
        }).prop('selected', true).trigger('change');

        // Update the Add to Cart button price
        updateAddToCartPrice($selectDropdown.find('option:selected').text().split('-').pop().trim());
    });
    
});